import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';
import type { Attachment } from '@/types/attachment';

export function useExpenseAttachments(expenseId: string) {
  return useApiQuery<Attachment[]>({
    queryKey: expenseKeys.attachments(expenseId),
    queryFn: () => apiGet<Attachment[]>(operationsClient, expenseEndpoints.attachments(expenseId)),
    enabled: Boolean(expenseId),
    showErrorToast: false,
  });
}
